import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store";

import { ToastContainer, toast } from "react-toastify";

import { db } from "config/firebase";
import { doc, deleteDoc } from "firebase/firestore";
import { setNotifications } from "../../store/actions";

interface Notification {
  id: string;
  msg: string;
  status: "pending" | "declined" | "waitlist" | "confirmationPending" | "hostConfirmed" | "playerDeclined" | "playerConfirmed";
}

function Notifications() {
  const dispatch = useDispatch();
  const notifications = useSelector((state: RootState) => state.messages.notifications) as Notification[];

  useEffect(() => {
    renderNotifications();
  }, [notifications]);

  const updateOnClose = (id: string) => {
    const updatedNotifications = notifications.filter(notification => notification.id !== id);
    return dispatch(setNotifications(updatedNotifications));
  };

  const removeOnClose = async (id: string) => {
    try {
      await deleteDoc(doc(db, "notifications", id));
    } catch (error) {
      console.log("Error deleting notification:", error);
    }
  };

  const renderNotifications = () => {
    for (let i = 0; i < notifications.length; i++) {
      const noteData = notifications[i];
      const delay = i * 100;

      switch (noteData.status) {
        case "pending":
          toast.info(`${noteData.msg}`, {
            position: "top-right",
            toastId: noteData.id,
            delay,
            onClose: () => removeOnClose(noteData.id),
          });
          break;
        case "declined":
          toast.error(`${noteData.msg}`, {
            position: "top-left",
            toastId: noteData.id,
            delay,
            onClose: () => removeOnClose(noteData.id),
          });
          break;
        case "waitlist":
          toast.success(`${noteData.msg}`, {
            position: "top-left",
            toastId: noteData.id,
            delay,
            onClose: () => removeOnClose(noteData.id),
          });
          break;
        case "confirmationPending":
          toast.info(`${noteData.msg}`, {
            position: "top-center",
            toastId: noteData.id,
            delay,
            onClose: () => removeOnClose(noteData.id),
          });
          break;
        case "hostConfirmed":
          toast.success(`${noteData.msg}`, {
            position: "top-right",
            toastId: noteData.id,
            delay,
            onClose: () => removeOnClose(noteData.id),
          });
          break;
        case "playerDeclined":
          toast.error(`${noteData.msg}`, {
            position: "top-right",
            toastId: noteData.id,
            delay,
            onClose: () => removeOnClose(noteData.id),
          });
          break;
        case "playerConfirmed":
          toast.success(`${noteData.msg}`, {
            position: "top-center",
            toastId: noteData.id,
            delay,
            onClose: () => removeOnClose(noteData.id),
          });
          break;
        default:
          toast(`${noteData.msg} but this condition is not accounted for`, {
            position: "bottom-center",
            toastId: noteData.id,
            delay,
            onClose: () => removeOnClose(noteData.id),
          });
      }
    }
  };

  return (
    <ToastContainer
      autoClose={10000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      limit={3}
    />
  );
}

export default Notifications;
